import { render } from "./LineFriendshipStatusError.vue?vue&type=template&id=13f07ada&ts=true"
import script from "./LineFriendshipStatusError.vue?vue&type=script&lang=ts"
export * from "./LineFriendshipStatusError.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__